"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.browserAlertOff = exports.browserAlertOn = void 0;
/* ++++++++++ --------------- BROWSER ALERT --------------- ++++++++++ */

var browserAlertOn = function browserAlertOn() {
  window.onbeforeunload = function () {
    return true;
  };
};

exports.browserAlertOn = browserAlertOn;

var browserAlertOff = function browserAlertOff() {
  window.onbeforeunload = null;
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */


exports.browserAlertOff = browserAlertOff;